// Load css file
const loadCss = (fileName) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");
    const fileId = `${fileName.toUpperCase()?.replace("-", "")}CSS`;
    const mainPath = document.getElementById("MainCssPath").href;
    link.onload = resolve;
    link.onerror = reject;
    link.id = fileId;
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = mainPath.includes("?v")
      ? mainPath
          .split("?v")[0]
          ?.replace(
            "/assets/main.css",
            `/assets/${fileName}.css?v=${Math.floor(Math.random() * 10000)}`
          )
      : mainPath.replace(
          "/assets/main.css",
          `/assets/${fileName}.css?v=${Math.floor(Math.random() * 10000)}`
        );
    link.media = "all";
    if (!document.getElementById(fileId)) {
      document.head.appendChild(link);
    }
  });
};
// Load js file
const loadScript = (fileName) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    const fileId = `${fileName.toUpperCase()?.replace("-", "")}JS`;
    const mainPath = document.getElementById("MainJsPath").src;
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.id = fileId;
    script.type = "text/javascript";
    script.src = mainPath.includes("?v")
      ? mainPath
          .split("?v")[0]
          ?.replace(
            "/assets/main.js",
            `/assets/${fileName}.js?v=${Math.floor(Math.random() * 10000)}`
          )
      : mainPath.replace(
          "/assets/main.js",
          `/assets/${fileName}.js?v=${Math.floor(Math.random() * 10000)}`
        );
    if (!document.getElementById(fileId)) {
      document.head.appendChild(script);
    }
  });
};
// Scroll animation observer
const scrollAnimationObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("scroll-animation--active");
        scrollAnimationObserver.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.25,
  }
);

(function scrollAnimationInit() {
  if (!document.documentElement.classList.contains("js-animations--accent"))
    return;

  document.querySelectorAll(".scroll-animation").forEach((el, i) => {
    scrollAnimationObserver.observe(el);
  });
})();
// Add helper class when announcement bar is enabled
window.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".announcement-bar") != null) {
    document.body.classList.add("is-announcement-bar");
  }
});
// Helper functions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, shop-pay-wallet-button, shopify-paypal-button, shopify-google-pay-button"
    )
  );

  return Array.from(allFocusable).filter((el) => {
    return isElementVisible(el);
  });
}

function isElementVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  document.querySelector("shopify-google-pay-button")?.setAttribute("tabindex", "0");

  const shopPayButton = document.querySelector("shop-pay-wallet-button")?.shadowRoot?.querySelector("button");
  const googlePayButton = document.querySelector("shopify-google-pay-button")?.shadowRoot?.querySelector("button");
  const paypalButton = document.querySelector("shopify-paypal-button")?.shadowRoot?.querySelector("button");

  if (shopPayButton) {
    elements.push(shopPayButton);
  }
  if (googlePayButton) {
    elements.push(googlePayButton);
  }
  if (paypalButton) {
    elements.push(paypalButton);
  }

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
// Details animation
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.classList.remove('details--active');  
  summaryElement.setAttribute('aria-expanded', false);
  setTimeout(() => {
    openDetailsElement.removeAttribute("open");
  }, 500);
  if (
    summaryElement.classList.contains("mmenu__hamburger") &&
    document.body.classList.contains("mmenu--open")
  ) {
    document.body.classList.remove("mmenu--open");
  }
  summaryElement.focus();
}
class Accordion {
  constructor(el) {
    this.details = el;
    this.summary = el.querySelector("summary");
    this.content = el.querySelector(".details__content");

    this.summary.addEventListener("click", (event) => this.onClick(event));
    this.details.addEventListener("keyup", onKeyUpEscape);
    window.addEventListener("DOMContentLoaded", this.mobileOnlyDetails());
    window.addEventListener("resize", () => {
      this.mobileOnlyDetails();
    });
  }

  onClick(event) {
    event.preventDefault();
    event.currentTarget.setAttribute(
      "aria-expanded",
      !this.details.hasAttribute("open")
    );

    if (this.details.hasAttribute("open")) {
      this.collapse();
    } else {
      this.expand();
    }

    if (this.summary.classList.contains("mmenu__hamburger")) {
      document.body.classList.toggle("mmenu--open");
    }
  }

  collapse() {
    this.details.classList.remove("details--active");
    setTimeout(() => {
      this.details.removeAttribute("open");
    }, 500);
  }

  expand() {
    this.details.setAttribute("open", "");
    setTimeout(() => {
      this.details.classList.add("details--active");
    }, 250);

    if (this.summary.classList.contains("mmenu__hamburger")) {
      setTimeout(() => {
        document.getElementById("mm__close").focus();
      }, 250);
    }
  }

  mobileOnlyDetails() {
    if (this.details.classList.contains("mobile--only")) {
      if (window.innerWidth < 769) {
        this.collapse();
      } else {
        this.expand();
      }
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.site-menu .open-megamenu-trigger')?.forEach((triggerEl) => {
    triggerEl.addEventListener('keydown', (e) => {
      if(e.code === 'Enter') {
        e.preventDefault();
        let parentDetailsContainer = e.target.parentElement;
        if (parentDetailsContainer.classList.contains('submenu--expanded')) {
          parentDetailsContainer.classList.remove('submenu--expanded');
        } else {
          parentDetailsContainer.classList.add('submenu--expanded');
        }
      }
    });
  });
});

document.querySelectorAll('[id^="Details-"]').forEach((el) => {
  new Accordion(el);
});
// Check if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}
// Variant select
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(false, true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(false, true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const variantImage = this.currentVariant.featured_media.preview_image.src;
    //console.log(variantImage)

    if (this.closest(".product-card")) {
      const media = this.closest(".product-card").querySelector(
        ".product-card__media .media--primary"
      );
      media.innerHTML = `<img src="${variantImage}&width=1440">`;
    } else {
      const carousel = document.querySelector("#main-carousel");
      if (!carousel) return;
      const media = carousel.querySelector(
        `.splide__slide[data-media-position="${this.currentVariant.featured_media.position}"]`
      );
      const mediaContainer = carousel.querySelector(".splide__list");

      if (carousel.classList.contains("is-active")) {
        var Slides = main.Components.Slides.filter(".product__media-item");

        if (Slides[this.currentVariant.featured_media.position]) {
          if (carousel.classList.contains("splide--loop")) {
            main.go(
              Slides[this.currentVariant.featured_media.position].index + 1
            );
          } else {
            main.go(
              Slides[this.currentVariant.featured_media.position].index - 1
            );
          }
        }
      } else {
        media.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }
  }

  updateURL() {
    if (
      !this.closest(".product-wrapper") ||
      !this.currentVariant ||
      this.dataset.updateUrl === "false"
    )
      return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    const urlInput = shareButton.querySelector("input");
    let urlToShare = urlInput ? urlInput.value : document.location.href;
    const url = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
    urlToShare = url;
    urlInput.value = url;
  }

  updateVariantInput() {
    if (this.closest(".product-card")) {
      if (this.closest("form")) {
        const productCardInput =
          this.closest("form").querySelector('input[name="id"]');
        productCardInput.value = this.currentVariant.id;
        productCardInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    } else {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);

      // Update slected option label
      this.querySelectorAll(":checked").forEach((el) => {
        if (
          el.closest(".product-form__input").querySelector("#selectedOption")
        ) {
          el
            .closest(".product-form__input")
            .querySelector("#selectedOption").textContent = el.value;
        }
      });
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.style.display = "block";
    } else {
      pickUpAvailability.style.display = "none";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url.split("?")[0]}.json`)
      .then((response) => response.json())
      .then((data) => {
        const variant = data.product.variants.filter((v) => {
          return v.id === this.currentVariant.id;
        });

        //console.log(variant)

        const symbol = document
          .querySelectorAll(".price-item")[0]
          .innerHTML.charAt(0);
        let currency = document
          .querySelectorAll(".price-item")[0]
          .innerHTML.split(" ")[1];
        if (currency == undefined) currency = "";
        let price, compare_price, saleBadge;
        const soldOutBadge = document.querySelector(
          ".product__info .badge--sold"
        );
        let compare_at_price = variant[0].compare_at_price;

        if (this.closest(".product-card")) {
          price = this.closest(".product-card").querySelector(
            ".price-item--regular"
          );
          compare_price = this.closest(".product-card").querySelector(
            ".price-item--compare"
          );
          saleBadge =
            this.closest(".product-card").querySelector(".badge--sale");
        } else {
          price = this.closest(".product__info").querySelector(
            ".price-item--regular"
          );
          compare_price = this.closest(".product__info").querySelector(
            ".price-item--compare"
          );
          saleBadge =
            this.closest(".product__info").querySelector(".badge--sale");
        }

        if (price.closest(".price").querySelector(".price-varies__label")) {
          price
            .closest(".price")
            .querySelector(".price-varies__label")
            .remove();
        }

        if (
          compare_at_price &&
          Number(compare_at_price) > Number(variant[0].price)
        ) {
          if (compare_price) {
            compare_price.innerHTML =
              symbol + compare_at_price.replace(".00", "") + " " + currency;
          } else {
            const comparePriceNew = document.createElement("s");
            comparePriceNew.className += "price-item price-item--compare";
            comparePriceNew.textContent =
              symbol + compare_at_price.replace(".00", "") + " " + currency;

            const saleBadgeNew = document.createElement("span");
            saleBadgeNew.className += "badge badge--sale";
            saleBadgeNew.textContent = "Sale";

            price
              .closest(".price-item--regular")
              .parentNode.insertBefore(
                comparePriceNew,
                price.closest(".price-item--regular").nextSibling
              );

            if (!this.closest(".product-card")) {
              price
                .closest(".price-item--regular")
                .parentNode.insertBefore(
                  saleBadgeNew,
                  comparePriceNew.nextSibling
                );
            }
          }
        } else {
          if (compare_price) compare_price.remove();
          if (saleBadge) saleBadge.remove();
        }

        price.textContent =
          symbol + variant[0].price.replace(".00", "") + " " + currency;

        if (!this.currentVariant.available) {
          if (soldOutBadge) {
            soldOutBadge.removeAttribute("hidden");
          } else {
            const soldOutBadgeNew = document.createElement("span");
            soldOutBadgeNew.className += "badge badge--sold";
            soldOutBadgeNew.textContent = "Sold Out";

            if (!this.closest(".product-card")) {
              price.closest(".price").append(soldOutBadgeNew);
            }
          }
        } else {
          if (soldOutBadge) {
            soldOutBadge.setAttribute("hidden", "");
          }
        }

        let isPreorder = false;
        if (document.getElementById("variantJSONData")) {
          const variantJSONData = JSON.parse(
            document.getElementById("variantJSONData").textContent
          );
          function getPreorderDate(selectedSize) {
            const matchingVariant = variantJSONData.find(
              (variant) =>
                variant.options && variant.options[1] === selectedSize
            );

            return matchingVariant &&
              matchingVariant.metafields &&
              matchingVariant.metafields.custom
              ? matchingVariant.metafields.custom.preorder_date
              : null;
          }

          const preorderDate = getPreorderDate(this.currentVariant.option2);
          const lineItemPorperty = document.getElementById("preorder");

          if (preorderDate) {
            document.getElementById("preorderDate").textContent = preorderDate;
            lineItemPorperty.setAttribute("name", "properties[Preorder]");
            lineItemPorperty.value = preorderDate;
            isPreorder = true;
          } else {
            if (document.getElementById("preorderDate")) {
              document.getElementById("preorderDate").textContent = null;
            }
            if (document.getElementById("preorderDate")) {
              lineItemPorperty.removeAttribute("name");
              lineItemPorperty.value = "";
            }
          }
        }

        this.toggleAddButton(
          isPreorder,
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(isPreorder, disable = true, text, modifyClass = true) {
    let productForm;

    if (this.closest(".product-card")) {
      productForm = this.closest("form");
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      if (isPreorder) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      addButton.removeAttribute("disabled");      
    }    
    
    if (!modifyClass) return;
  }

  setUnavailable() {
    let productForm;
    if (this.closest(".product-card")) {
      productForm = this.closest("form");
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (addButton) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }

    if (addButton.hasAttribute("hidden")) {
      addButton.removeAttribute("hidden");
      setTimeout(() => addButton.setAttribute("hidden", ""), 3000);
    } else {
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);
// Variant radios
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("sold-out");
      } else {
        input.classList.add("sold-out");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("variant-radios", VariantRadios);
// Main drawer
class MainDrawer extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector(".drawer__trigger");
    this.drawer = this.querySelector(".drawer");
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.closeDrawer()
    );
    this.querySelectorAll(".drawer-close").forEach((el) =>
      el.addEventListener("click", () => this.closeDrawer())
    );
    if (this.trigger) {
      this.trigger.addEventListener("click", () => this.openDrawer());
    }

    this.setFocus = debounce((event) => {
      const container = this.querySelector('.drawer__container');

      container.querySelector('.drawer-close').focus();
      trapFocus(container, container);
    }, 300);
  }

  openDrawer() {
    this.setFocus();
    this.drawer.classList.add("drawer--active");
    document.body.classList.add("drawer--open");
  }

  closeDrawer() {
    this.drawer.classList.remove("drawer--active");
    setTimeout(() => {
      document.body.classList.remove("drawer--open");
    }, 500);
    document.activeElement.blur();
  }
}
customElements.define("main-drawer", MainDrawer);
// Search drawer
class SearchDrawer extends MainDrawer {
  constructor() {
    super();

    this.setFocus = debounce((event) => {
      trapFocus(this, this.querySelector(".search-drawer"));
      document.getElementById("SearchInput").focus();
    }, 300);

    document
      .getElementById("SearchDrawerTrigger")
      .addEventListener("click", (e) => {
        this.openDrawer();
        this.setFocus();
        if (
          !document.getElementById("PREDICTIVESEARCHCSS") &&
          document.getElementById("PREDICTIVESEARCHJS")
        ) {
          this.classList.add("loading");
        }
        if (this.querySelector("predictive-search")) {
          loadScript("predictive-search").catch((error) => {
            console.error(error);
          });
          loadCss("predictive-search")
            .then(() => {
              setTimeout(() => {
                this.classList.remove("loading");
              }, 300);
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
  }
}
customElements.define("search-drawer", SearchDrawer);
// Modal dialog
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.lastFocusedElement = null;
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.hide()
    );
    this.querySelectorAll(".modal__close").forEach((el) =>
      el.addEventListener("click", () => this.hide())
    );
    this.querySelector(".modal-trigger").addEventListener(
      "click",
      this.show.bind(this)
    );
  }

  hide() {
    this.querySelector("dialog").removeAttribute("open");
    this.querySelector(".modal").classList.remove("modal--active");
    document.body.classList.remove("modal--open");
    if (predictiveSearch) {
      removeTrapFocus(predictiveSearch);
      if (this.observer) {
        this.observer.disconnect();
      }
    } else {
      removeTrapFocus(this);
      if (this.lastFocusedElement) {
        this.lastFocusedElement.focus();
      }
    }
  }

  show() {
    this.lastFocusedElement = document.activeElement;
    this.querySelector("dialog").setAttribute("open", "");
    this.querySelector(".modal").classList.add("modal--active");
    document.body.classList.add("modal--open");
    
    let container = this.querySelector('.modal__container')

    trapFocus(container);
    quickViewEvent(this);
  }
}
customElements.define("modal-dialog", ModalDialog);
// Search dialog
class SearchDialog extends ModalDialog {
  constructor() {
    super();

    this.querySelector(".modal-trigger").addEventListener(
      "click",
      this.loadAssets.bind(this)
    );
  }

  loadAssets() {
    this.show();
    setTimeout(() => {
      document.getElementById("SearchInput").focus();
    }, 500);
    if (this.querySelector("predictive-search")) {
      if (
        !document.getElementById("PREDICTIVESEARCHCSS") &&
        !document.getElementById("PREDICTIVESEARCHJS")
      ) {
        this.classList.add("loading");
      }
      loadScript("predictive-search").catch((error) => {
        console.error(error);
      });
      loadCss("predictive-search")
        .then(() => {
          setTimeout(() => {
            this.classList.remove("loading");
          }, 300);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
customElements.define("search-dialog", SearchDialog);
// Back to top
(function backToTop() {
  const trigger = document.querySelector(".btn--back-to-top");

  if (trigger) {
    const backToTopReveal = (e) => {
      if (window.pageYOffset >= 50) {
        trigger.classList.add("btn--back-to-top__revealed");
      } else {
        trigger.classList.remove("btn--back-to-top__revealed");
      }
    };

    backToTopReveal();
    window.addEventListener("scroll", backToTopReveal);

    trigger.addEventListener("click", (e) => {
      window.scrollTo({ top: 0, behavior: "smooth" });

      setTimeout(() => {
        const focusableElements = document.querySelectorAll(
          'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
        );
        if (focusableElements.length > 0) {
          focusableElements[0].focus();
        }
      }, 1000);
    });
  }
})();

// Page transition
window.addEventListener("beforeunload", () => {
  document.body.classList.remove("page-loaded");
  document.body.classList.add("page-unloading");
});
window.addEventListener("DOMContentLoaded", () => {
  document.body.classList.remove("page-unloading");
  document.body.classList.add("page-loaded");
});
window.addEventListener("pageshow", (event) => {
  // Removes unload class when returning to page via history
  if (event.persisted) {
    document.body.classList.remove("page-unloading");
  }
});

const productFormObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadScript("product-form").catch((error) => {
          console.error(error);
        });
        productFormObserver.unobserve(entry.target);
      }
    });
  },
  { rootMargin: "0px 0px 250px 0px" }
);

document
  .querySelectorAll("[product-form-oberver]")
  .forEach((el) => productFormObserver.observe(el));

const imageObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("loaded");
        imageObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.25 }
);

document
  .querySelectorAll('img[loading="lazy"]')
  .forEach((el) => imageObserver.observe(el));

//Quick add
(() => {
  Array.from(document.getElementsByClassName("mobile-quick-add")).forEach(
    (el) => {
      el.addEventListener("click", (e) => {
        if (e.target.parentNode.classList.contains("mobile-quick-add-open")) {
          e.target.parentNode.classList.remove("mobile-quick-add-open");
        } else {
          e.target.parentNode.classList.add("mobile-quick-add-open");
        }
      });
      if (el.parentNode.getElementsByClassName("size").length > 0) {
        Array.from(
          el.parentNode
            .getElementsByClassName("size")[0]
            .getElementsByClassName("variant-option")
        ).forEach((input) => {
          input.addEventListener("click", (e) => {
            if (window.innerWidth <= 768) {
              setTimeout(() => {
                el.parentNode
                  .getElementsByClassName("product-form__submit")[0]
                  .click();
              }, 500);
            }
          });
        });
      }
    }
  );
})();

// Custom Mobile Menu
(() => {
  // Level 0 toggles (main menu to submenu)
  Array.from(document.querySelectorAll(".mm__toggle.mm__level-0")).forEach((el) => {
    el.addEventListener("click", (e) => {
      let button = e.currentTarget;
      if (!button.parentNode.classList.contains("mm__submenu--active")) {
        button.parentNode.classList.add("mm__submenu--active");
        button.parentNode.parentNode.classList.add("has-active-submenu");
        button.setAttribute("aria-expanded", true);
        document.getElementById("mm__close-submenu").focus();

        let levelOneElements = button.parentNode.parentNode.querySelectorAll('.mm__level-0')
        levelOneElements.forEach(function(el) { el.setAttribute('tabindex', -1); })

        // trap focus
        let container = button.parentNode;
        let firstFocusableEl = document.getElementById("mm__close-submenu");
        let aArr = Array.from(container.getElementsByTagName("a"));
        let lastFocusableEl = aArr[aArr.length - 1];
        container.addEventListener("keydown", (e) => {
          if (e.target == lastFocusableEl && e.key == "Tab" && !e.shiftKey) {
            e.preventDefault();
            firstFocusableEl.focus();
          }
        });

        function trapFocusCloseHandler(e, lastEl) {
          if (e.key == "Tab" && e.shiftKey) {
            e.preventDefault();
            lastEl.focus();
          }
        }
        const trapFocusClose = (e) => trapFocusCloseHandler(e, lastFocusableEl);

        document
          .getElementById("mm__close-submenu")
          .addEventListener("keydown", trapFocusClose);
        document
          .getElementById("mm__close-submenu")
          .addEventListener("click", (e) => {
            document
              .getElementById("mm__close-submenu")
              .removeEventListener("keydown", trapFocusClose);
          });
      }
    });
  });

  // Level 1 toggles (submenu to grandchild submenu)
  Array.from(document.querySelectorAll(".mm__toggle.mm__level-1")).forEach((el) => {
    el.addEventListener("click", (e) => {
      let button = e.currentTarget;
      if (!button.parentNode.classList.contains("mm__grandchild-submenu--active")) {
        button.parentNode.classList.add("mm__grandchild-submenu--active");
        button.closest(".mm__submenu").classList.add("has-active-grandchild-submenu");
        button.setAttribute("aria-expanded", true);
      }
    });
  });
  document
    .getElementById("mm__close-submenu")
    .addEventListener("click", (e) => {
      document
        .getElementsByClassName("has-active-submenu")[0]
        .classList.remove("has-active-submenu");
      Array.from(
        document.getElementsByClassName("mm__submenu--active")
      ).forEach((el) => {
        el.classList.remove("mm__submenu--active");
      });
    });

  // Back button for main submenu (data-back-to-main)
  Array.from(document.querySelectorAll("[data-back-to-main]")).forEach((el) => {
    el.addEventListener("click", (e) => {
      document
        .getElementsByClassName("has-active-submenu")[0]
        .classList.remove("has-active-submenu");
      Array.from(
        document.getElementsByClassName("mm__submenu--active")
      ).forEach((el) => {
        el.classList.remove("mm__submenu--active");
      });
    });
  });

  // Back button for grandchild submenu (data-back-to-submenu)
  Array.from(document.querySelectorAll("[data-back-to-submenu]")).forEach((el) => {
    el.addEventListener("click", (e) => {
      let button = e.target.closest("[data-back-to-submenu]");
      let grandchildContainer = button.closest(".mm__grandchild-submenu").parentNode;
      grandchildContainer.classList.remove("mm__grandchild-submenu--active");
      button.closest(".mm__submenu").classList.remove("has-active-grandchild-submenu");
    });
  });

  document.getElementById("mm__close").addEventListener("click", (e) => {
    document
      .getElementById("Details-Menu-Trigger")
      .classList.remove("details--active");
    document
      .getElementsByClassName("mmenu__hamburger")[0]
      .setAttribute("aria-expanded", false);
    document.body.classList.remove("mmenu--open");
    setTimeout(() => {
      document.getElementById("Details-Menu-Trigger").removeAttribute("open");
    }, 500);
  });

  //trap level 0 focus
  const mmClose = document.getElementById("mm__close");
  const level0Arr = Array.from(document.getElementsByClassName("mm__level-0"));
  const lastLevel0 = level0Arr[level0Arr.length - 1];
  lastLevel0.addEventListener("keydown", (e) => {
    if (e.key == "Tab" && !e.shiftKey) {
      e.preventDefault();
      mmClose.focus();
    }
  });
  mmClose.addEventListener("keydown", (e) => {
    if (e.key == "Tab" && e.shiftKey) {
      e.preventDefault();
      lastLevel0.focus();
    }
  });
})();

//PDP - Mobile size guide button - triggers modal
(() => {
  // if(document.getElementsByClassName('size-guide-mobile').length > 0){
  //   document.getElementsByClassName('size-guide-mobile')[0].addEventListener('click', e => {
  //     document.getElementsByClassName('size-guide-btn')[0].click();
  //   })
  // }
  if (document.getElementsByClassName("size-guide-trigger").length > 0) {
    document
      .getElementsByClassName("size-guide-trigger")[0]
      .addEventListener("click", (e) => {
        document.getElementsByClassName("size-guide-btn")[0].click();
      });
  }
})();

// Customize instafeed
(() => {
  if (document.getElementById("insta-feed") != null) {
    let counter = 0;
    let waitForInstafeed = setInterval(() => {
      counter++;
      if (document.getElementsByClassName("instafeed-container").length > 0) {
        customizeInstafeed();
        clearInterval(waitForInstafeed);
      } else if (counter === 20) {
        clearInterval(waitForInstafeed);
      }
    }, 250);
  } // if insta-feed is found

  function customizeInstafeed() {
    let instafeed = document.getElementById("insta-feed");
    let html = `<div class="splide" id="instafeed-splide" aria-label="insta feed"><div class="splide__track"><ul class="splide__list list-unstyled">`;
    Array.from(instafeed.getElementsByClassName("instafeed-container")).forEach(
      (el, i) => {
        html += `<li class="splide__slide"><div class="instafeed-container insta_slide" data-index="${i}">${el.innerHTML}</div></li>`;
      }
    );
    html += `</ul></div></div>`;
    instafeed.insertAdjacentHTML("afterend", html);

    setTimeout(() => {
      const instaSplide = document.querySelector("#instafeed-splide");
      const splide = new Splide(instaSplide, {
        drag: true,
        pagination: false,
      });
      splide.mount();
      Array.from(document.getElementsByClassName("insta_slide")).forEach(
        (el) => {
          el.addEventListener("click", (e) => {
            let i = e.currentTarget.dataset.index;
            Array.from(document.getElementsByClassName("instafeed-container"))
              [i].getElementsByClassName("instafeed-overlay")[0]
              .click();
          });
        }
      );
      //unlazy load
      Array.from(instaSplide.getElementsByClassName("js-lazy-image")).forEach(
        (el) => {
          el.src = el.dataset.src;
        }
      );
    }, 50);
  }
})();

function quickViewEvent(modal) {
  //console.log('modal this')
  //console.log(modal)
  //console.log(modal.getElementsByClassName('quick-view'));
  if (modal.getElementsByClassName("quick-view").length == 0) {
    return;
  }

  let quickView = modal.getElementsByClassName("quick-view")[0];
  let quickViewInner = modal.getElementsByClassName("quick-view__inner")[0];

  if (quickView.classList.contains("quick-view--multiple-products")) {
    let thumbs = Array.from(
      quickView
        .getElementsByClassName("thumbs")[0]
        .getElementsByClassName("splide__slide")
    );

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", (e) => {
        const productId = quickViewInner.dataset.productId;
        const name = quickViewInner.dataset.title;
        const value = quickViewInner.dataset.price * 0.01;
        viewEvent(productId, name, value);
        //viewEvent(thumb.dataset.productId, thumb.dataset.title, (thumb.dataset.price * 0.01));
      });
    });
  }

  const productId = quickViewInner.dataset.productId;
  const name = quickViewInner.dataset.title;
  const value = quickViewInner.dataset.price * 0.01;
  viewEvent(productId, name, value);

  function viewEvent(productId, name, value) {
    const currency = Shopify.currency.active;
    let item = {
      item_id: productId,
      item_name: name,
      price: value,
    };

    let obj = {
      currency: currency,
      value: value,
      items: [item],
    };
    gtag("event", "view_item", obj);
    //console.log('view_item')
    //console.log(obj)
  }
}


// Search form is focused
window.addEventListener('DOMContentLoaded', () => {
  searchContainer = document.querySelector('.template-search .input-wrapper');
  searchInput = searchContainer && searchContainer.querySelector("#Search-In-Template");

  const focusInHandler = function() {
    searchContainer.classList.add('is-floating');
  }

  const focusOutHandler = function() {
    if (searchInput.value == "") {
      searchContainer.classList.remove('is-floating');
    }
  }

  if (searchInput) {
    if (searchInput.value != "") {
      searchContainer.classList.add('is-floating');
    }
    searchInput.addEventListener('focus', focusInHandler);
    searchInput.addEventListener('focusout', focusOutHandler);
  }
});

// Login form elements focused
window.addEventListener('DOMContentLoaded', () => {
  const loginContainer = document.querySelector('.login-content__wrapper');
  loginInputWrappers = loginContainer && loginContainer.querySelectorAll(".input-wrapper");


  const focusInHandler = function(e) {
    const target = e.target;
    target.closest('.input-wrapper').classList.add('is-floating');
  }

  const focusOutHandler = function(e) {
    const target = e.target;
    if (target.value == "") {
      target.closest('.input-wrapper').classList.remove('is-floating');
    }
  }

  loginInputWrappers && loginInputWrappers.forEach(function(wrapperElement) {
    const inputElement = wrapperElement.querySelector('input');

    if (inputElement.value != "") {
      wrapperElement.classList.add('is-floating');
    }
    inputElement.addEventListener('focus', focusInHandler);
    inputElement.addEventListener('focusout', focusOutHandler);
  });
});

// Recover password form is focused
window.addEventListener('DOMContentLoaded', () => {
  recoverContainer = document.querySelector('#recover .input-wrapper');
  recoverInput = recoverContainer && recoverContainer.querySelector("#RecoverEmail");

  const focusInHandler = function() {
    recoverContainer.classList.add('is-floating');
  }

  const focusOutHandler = function() {
    if (recoverInput.value == "") {
      recoverContainer.classList.remove('is-floating');
    }
  }

  if (recoverInput) {
    if (recoverInput.value != "") {
      recoverContainer.classList.add('is-floating');
    }
    recoverInput.addEventListener('focus', focusInHandler);
    recoverInput.addEventListener('focusout', focusOutHandler);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(() => {
    const component = document.querySelector('shopify-payment-terms');
    if (component && component.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        p {
          font-family: var(--font-body) !important;
          font-size: 11px !important;
          line-height: 145% !important;
        }
      `;
      component.shadowRoot.appendChild(style);
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
